import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import BatchCreateForm from "./-form";
import { BatchCrumbs } from "./-crumbs";

const searchSchema = z.object({
  warehouseId: z.number().optional(),
});

export const Route = createFileRoute("/_private/_warehouse-360/batch/create")({
  validateSearch: searchSchema,
  component: BatchCreatePage,
});

function BatchCreatePage() {
  return (
    <div>
      <title>Create Batch - Legrande Health Portal</title>
      <BatchCrumbs />

      <Card>
        <CardHeader>
          <CardTitle>Create Batch</CardTitle>
        </CardHeader>
        <CardContent>
          <BatchCreateForm />
        </CardContent>
      </Card>
    </div>
  );
}
